export enum ContentLanguage {
  PT = "pt-pt",
}
